const WORDS = [
  "CCTV",
  "Access Control",
  "Intercoms",
  "LR Systems",
  "Maintenance",
  "Domestic",
  "Commercial",
];

export const Marquee = () => {
  const row = [...WORDS, ...WORDS];
  return (
    <section
      data-testid="marquee"
      className="relative border-y border-white/10 bg-[#080808] py-6 overflow-hidden"
    >
      <div className="flex w-max animate-marquee whitespace-nowrap will-change-transform">
        {row.map((w, i) => (
          <div key={i} className="flex items-center">
            <span className="font-display text-4xl md:text-6xl font-semibold tracking-tight px-8 text-white/90">
              {w}
            </span>
            <span className="text-cyanbrand text-3xl md:text-5xl">✦</span>
          </div>
        ))}
      </div>
    </section>
  );
};
